export interface IArticleItem {
    title: string;
    description: string;
    imageUrl: string;
    publishDate: string;
    categories: string[];
    link: string;
} 

export interface GetArticlesResponse {
    results: IArticleItem[];
    totalResults: number;
}

export interface FilterResponseItem {
    name: string;
    label: string;
    values: string[];
}
export enum SortOrder {
    Newest = "newest",
    Oldest = "oldest"
}